function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import DealsLayout from "../DealsLayout/newIndex";
import { getCategoryIdByName } from "../../../../utils/helpers";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DealSection(_ref) {
  var _ref2;
  var offers = _ref.offers,
    type = _ref.type,
    className = _ref.className,
    hide = _ref.hide,
    isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    subHeading = _ref.subHeading,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    appType = _ref.appType,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    cmsClient = _ref.cmsClient;
  // Some sections should fill a fixed number of rows based on the available
  // screen width. The cards are fixed-width inside a flex-wrap container, so
  // the number of columns per row varies with the container width rather than
  // with fixed breakpoints. We measure the layout at runtime to figure out how
  // many cards fit in one row and then show (columns * rowsToShow) offers.
  //   - OFFERS OF THE MONTH => 2 rows (4 deals on mobile)
  //   - category sections    => 1 row
  var isOffersOfMonth = type === "OFFERS OF THE MONTH";
  var singleRowTypes = ["Home Services", "Home Furnishings", "Lifestyle", "Electronics", "Finance"];
  var isSingleRow = singleRowTypes.includes(type);
  var usesRowLayout = isOffersOfMonth || isSingleRow;
  var rowsToShow = isOffersOfMonth ? 2 : 1;
  var layoutRef = useRef(null);
  // Default assumes 2 columns so the first paint on mobile is correct.
  var _useState = useState(2 * rowsToShow),
    _useState2 = _slicedToArray(_useState, 2),
    visibleCount = _useState2[0],
    setVisibleCount = _useState2[1];
  useLayoutEffect(function () {
    if (!usesRowLayout) return;
    var computeVisibleCount = function computeVisibleCount() {
      var container = layoutRef.current;
      if (!container) return;
      var firstCard = container.children[0];
      if (!firstCard) return;

      // Derive columns from the container width and a single card's width so
      // the result stays correct even while later cards are hidden. The gap
      // is read from the computed flex gap (falls back to 0 if unset).
      var containerWidth = container.clientWidth;
      var cardWidth = firstCard.getBoundingClientRect().width;
      if (!cardWidth) return;
      var gap = parseFloat(window.getComputedStyle(container).columnGap) || 0;

      // columns * cardWidth + (columns - 1) * gap <= containerWidth
      var columns = Math.floor((containerWidth + gap) / (cardWidth + gap));
      if (columns < 1) columns = 1;
      setVisibleCount(columns * rowsToShow);
    };
    computeVisibleCount();
    window.addEventListener("resize", computeVisibleCount);
    return function () {
      return window.removeEventListener("resize", computeVisibleCount);
    };
  }, [usesRowLayout, rowsToShow, offers]);
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var onClick = function onClick() {
    var dealRoute = isRewards === true ? "/reward-dealListing" : "/dealListing";
    switch (type) {
      case "Home Services":
        history.push(dealRoute + "?categoryID=2&categoryName=Home Services");
        return;
      case "Home Furnishings":
        history.push(dealRoute + "?categoryID=11&categoryName=Home Furnishings");
        return;
      case "Lifestyle":
        history.push(dealRoute + "?categoryID=1&categoryName=Lifestyle");
        return;
      case "Electronics":
        history.push(dealRoute + "?categoryID=10&categoryName=Electronics");
        return;
      case "Finance":
        history.push(dealRoute + "?categoryID=3&categoryName=Finance");
        return;
      case "EXTERNAL OFFERS":
        history.push(dealRoute + "?categoryID=9&categoryName=External Deals");
        return;
      case "YOUR DIGITAL AMENITIES":
        history.push(dealRoute + "?categoryID=5&categoryName=Digital Amenities");
        return;
      case "OFFERS OF THE MONTH":
        offers.forEach(function (offer) {
          var _window;
          (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("OfferOfTheMonthClicked", {
            dealId: offer.id,
            category: offer.categoryName,
            tag: "Offers of the Month",
            SectionName: "".concat(isRewards === true ? "Rewards" : "Deals"),
            DealPoint: "".concat(offer === null || offer === void 0 ? void 0 : offer.points),
            Mrp: "".concat(offer === null || offer === void 0 ? void 0 : offer.productMrp),
            RedemptionType: "".concat(offer === null || offer === void 0 ? void 0 : offer.redemptionType)
          });
        });
        history.push(dealRoute + "?tagID=52&tagName=Offers of the Month");
        return;
      case "OTHER OFFERS FROM THIS BRAND":
        history.push("/dealListing?brandID=".concat(offers[0].vendorId, "&brandName=").concat(offers[0].vendorName));
        return;
      case "SIMILAR OFFERS":
        history.push("/dealListing?categoryID=".concat(getCategoryIdByName(offers[0].categoryName), "&categoryName=").concat(offers[0].categoryName));
        return;
      case "OTHER DEALS IN THIS BUNDLE":
        history.push(dealRoute + "?categoryID=8&categoryName=Bundle");
        return;
    }
  };
  var isDarkMode = Boolean(config === null || config === void 0 ? void 0 : config.darkMode);
  var fontBodyClass = config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontBody) || "" : "font-sans";
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex  ".concat(isRewards ? 'justify-center' : 'justify-between', " w-full items-center"),
      children: /*#__PURE__*/_jsx("h1", {
        onClick: onClick,
        className: "".concat(isPoints ? "".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " text-2xl lg:text-3xl text-center font-medium") : "font-semibold text-primary uppercase text-base", " ").concat(isRewards ? "" : "hover:border-b-2 hover:border-primary hover:pb-2 cursor-pointer"),
        children: type
      })
    }), subHeading && /*#__PURE__*/_jsx("p", {
      className: "".concat(isPoints ? "text-center mt-4 text-sm lg:text-lg" : ""),
      children: subHeading
    }), /*#__PURE__*/_jsx("div", {
      id: "DealsLayout",
      ref: layoutRef,
      className: "w-full gap-3 lg:gap-7 ".concat(isRewards ? "flex flex-wrap mt-8" : "flex flex-wrap mt-4"),
      children: (_ref2 = usesRowLayout ? offers === null || offers === void 0 ? void 0 : offers.slice(0, 12) : offers === null || offers === void 0 ? void 0 : offers.slice(0, 8)) === null || _ref2 === void 0 ? void 0 : _ref2.map(function (offer, index) {
        var responsiveClass = "";
        if (usesRowLayout) {
          // Keep every card in the DOM so we can measure how many fit in a
          // row, but visually hide anything past the rows we want to show.
          if (index >= visibleCount) {
            responsiveClass = "hidden";
          }
        } else if (index >= 4 && index < 6) {
          responsiveClass = "hidden md:block";
        } else if (index >= 6) {
          responsiveClass = "hidden lg:block";
        }
        var modifiedOffer = _objectSpread(_objectSpread({}, offer), {}, {
          isRewards: isRewards,
          isPoints: isPoints,
          config: config,
          redux: redux,
          router: router,
          appType: appType,
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        }); // Add isRewards to the offer object
        return /*#__PURE__*/_jsx("div", {
          className: responsiveClass,
          children: /*#__PURE__*/_jsx(DealsLayout, _objectSpread({}, modifiedOffer))
        }, (offer === null || offer === void 0 ? void 0 : offer.id) || (offer === null || offer === void 0 ? void 0 : offer.title) || index);
      })
    }), !hide && !isRewards && (usesRowLayout ? (offers === null || offers === void 0 ? void 0 : offers.length) > visibleCount : (offers === null || offers === void 0 ? void 0 : offers.length) >= 4) && /*#__PURE__*/_jsxs("div", {
      className: "relative flex items-center justify-center w-full my-8",
      children: [/*#__PURE__*/_jsx("div", {
        className: "absolute inset-0 flex items-center",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-full border-t ".concat(isDarkMode ? "border-primary" : "border-gray-300")
        })
      }), /*#__PURE__*/_jsx("button", {
        onClick: onClick,
        type: "button",
        className: "relative px-5 py-1.5 sm:px-7 sm:py-2 rounded-lg text-xs md:text-base font-medium tracking-wider uppercase cursor-pointer border transition-colors duration-200 ".concat(isDarkMode ? "bg-black border-primary text-primary" : "bg-white border-black text-black", " ").concat(fontBodyClass),
        children: "VIEW MORE"
      })]
    })]
  });
}
export default DealSection;